/* * @Author: 曹俊杰 * @Date: 2024-09-29 23:08:59 * @Last Modified by: 曹俊杰 * @Last
Modified time: 2025-02-16 23:10:02 */风险排查 是否核验三要素
<template>
  <div class="verification">
    <div class="item" :class="{ 'item-active': exposure }" @click="onClick('exposure')">
      <div class="top">
        <div class="left">
          <c-radio :value="exposure" />
          <div class="top-tit">曝光台检索</div>
          <div class="top-ico mianfei">免费</div>
        </div>
      </div>
      <div class="dsc">系统内曝光台进行检索，避免违约主播骗签</div>
    </div>
    <div class="item" :class="{ 'item-active': contract }" @click="onClick('contract')">
      <div class="top">
        <div class="left">
          <c-radio :value="contract" />
          <div class="top-tit">重复签约检索</div>
          <div class="top-ico mianfei">免费</div>
        </div>
      </div>
      <div class="dsc">系统内已签约信息检索，避免多次恶意签约</div>
    </div>
    <div
      class="item"
      :class="{ 'item-active': verification }"
      @click="onClick('verification')"
    >
      <div class="top">
        <div class="left">
          <c-radio :value="verification" />
          <div class="top-tit">三要素报告</div>
          <div class="top-ico shoufei">20元/次</div>
        </div>
      </div>
      <div class="dsc">根据大数据，结合被查询人手机号，对其签约风险进行判断</div>
    </div>
  </div>
</template>

<script>
import cRadio from "@/components/form/cRadio.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    cRadio,
  },
  computed: {
    verification: {
      get() {
        return this.$store.state.fengxian.verification;
      },
      set(value) {
        this.setVerification(value);
      },
    },
    exposure: {
      get() {
        return this.$store.state.fengxian.exposure;
      },
      set(value) {
        this.setExposure(value);
      },
    },
    contract: {
      get() {
        return this.$store.state.fengxian.contract;
      },
      set(value) {
        this.setContract(value);
      },
    },
  },
  methods: {
    ...mapActions("fengxian", ["setVerification", "setContract", "setExposure"]),
    onClick(key) {
      this[key] = !this[key];
    },
  },
};
</script>

<style lang="scss" scoped>
.verification {
  display: flex;

  .item:nth-child(3n - 1) {
    margin: 0 20px;
  }

  .item {
    cursor: pointer;
    width: 270px;
    height: 133px;
    border-radius: 4px;
    opacity: 1;

    /* 自动布局 */

    background: #fafafa;

    box-sizing: border-box;
    border: 1px solid #eeeeee;
    padding: 20px;

    .top {
      display: flex;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        gap: 6px;
      }
      &-tit {
        font-family: "Noto Sans SC";
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 1px;

        color: #262626;
      }

      &-ico {
        // height: 16px;
        // padding: 0 6px;
        font-family: "Noto Sans SC";
        font-size: 10px;
        font-weight: normal;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0px;
        border-radius: 2px;
        color: #0062ff;
        width: 32px;
        height: 16px;
        border-radius: 2px;
      }

      .mianfei {
        background: #e8f3ff;
        color: #0062ff;
      }

      .shoufei {
        color: #ff8412;
        background: #fff4e3;
        width: 48px;
      }
    }

    .dsc {
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 1px;

      color: #666666;
      margin-top: 10px;
    }
  }

  .item-active {
    border: 1.5px solid #0062ff;
    // background: #eff6ff;
    .top-tit {
      color: #0062ff;
    }
  }
}
</style>
